import { render, staticRenderFns } from "./updatePaymentOptionLimit.vue?vue&type=template&id=6633ed1f&lang=pug"
import script from "./updatePaymentOptionLimit.vue?vue&type=script&lang=js"
export * from "./updatePaymentOptionLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports